import React from 'react'
import FeatureNotImplemented from '../FeatureNotImplemented/FeatureNotImplemented'

const Invitation = () => {
  return (
    <div><FeatureNotImplemented msg="Invitation"/></div>
  )
}

export default Invitation